import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {paybill_lange} from "../../language/paybill";
import Swal from 'sweetalert2';
import { MyserviceService } from '../../provider/myservice.service';
import * as moment from 'moment';
declare var report_url;
@Component({
  selector: 'invoice-history',
  templateUrl: './invoice-history.html',
  styleUrls: ['./invoice-history.scss']
})
export class InvoiceHistory implements OnInit {
  actions=[
    {id:0,action_type:{TH:"แสดงรายการใบแจ้งให้มาชำระ",EN:"Invoice Dept Data"}},
    {id:1,action_type:{TH:"ชำระเงิน",EN:"Pay"}},

  ]
  paybills:any;
  all_paybill:any;
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  isLoading=true;
  action=this.actions[0];
  paybill:any;
  vat_price=0;
  payments:any;
  submitted=false;
  paytype="";
  check_payment="2";
  total_price:any;
  discount=0;
  remark="";
  sum=0;
  payment_id="";
  selected_items=[];
  search_obj={invoice_id:"",fee_id:"",fee_description:"",customer_id:"",customer_name:"",user_id:"",createDate:"",dueDate:"",fee_price:"",vat:"",vat_rate:"",total_price:"",address_TH:"",address_EN:""};
  constructor(private route:ActivatedRoute,router:Router,private service:MyserviceService) { }
  user:any
  ngOnInit() {
    this.refreshData();
    this.user=JSON.parse(sessionStorage.getItem('user'));
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=paybill_lange[this.lang];
      }else{
        this.language=paybill_lange[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
  }
  onSearchFee_type(event){
    console.log("comit");
    console.log(this.search_obj)
    this.paybills=this.all_paybill.filter((item)=>{
      // function compare(key){
      //   return item[key].toLowerCase().indexOf(this.search_obj[key].toLowerCase())>-1;
      // }
      var condiction=true;

      if(this.check_payment=="0"){
        condiction=condiction&&(!item.check);
      }else if(this.check_payment=="1"){
        condiction=condiction&&(item.check);
      }
      for(var key in this.search_obj){
        var a=""+(this.search_obj[key]);
        var b=""+item[key];

        // console.log(b);
        condiction=condiction&&(b.toLowerCase().indexOf(a.toLowerCase())>-1);
      }
      return condiction;

    })
    function compare(item,key){
      return item[key].toLowerCase().indexOf(this.search_obj[key].toLowerCase())>-1;
    }
  }
  hasSelected(){
    return this.all_paybill.filter((item)=>item.check).length>0;
  }
  print_invoice(invoice){
    const municipality_id=this.service.getDatabase().substring(0,5);
    const invoice_id=invoice.invoice_id;
    this.service.postData({invoice_id},"invoice/print-invoice").then((result)=>{
      window.open(report_url+"print-inform?invoice_id="+invoice_id+"&municipality_id="+municipality_id,"_blank");
    })
    
}
  refreshData(){
    this.submitted=false;
    this.action=this.actions[0];
    this.isLoading=true;
    this.service.postData({},"invoice/invoice-dept").then((result:any)=>{
      console.log(result);
      this.isLoading=false;
      this.all_paybill=result.data.filter((item)=>{
        var res:any;
        res=item;
        res.createDate=moment(item.create_datetime).format("DD/MM/YYYY");
        res.dueDate=moment(new Date(item.due_date)).format("DD/MM/YYYY");
        res.check=false;
        res.address_EN=item.place_address+' '+item["tambon_en"]+' '+item["amphur_en"]+' '+item["province_en"];
        res.address_TH=item.place_address+' '+item["tambon_th"]+' '+item["amphur_th"]+' '+item["province_th"];
        return res;
      });
      this.paybills=this.all_paybill;
    },(err)=>{
      console.log(err);
    })
  }
  check(item){
    item.check=!item.check;
  }
  update_bill(){
    this.submitted=true;
    // this.selected_items=this.all_paybill.filter((item)=>item.check);
    if(this.paytype!=""){
      Swal.fire({
        title: this.language.confirm_update,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.language.want_update,
        cancelButtonText: this.language.close
      }).then((result) => {

        if (result.value) {
          this.isLoading=true;
          this.service.postData({
            invoice_id:this.paybill.invoice_id,
            fee_id:this.paybill.fee_id,
            customer_id:this.paybill.customer_id,
            user_id:this.paybill.user_id,
            create_datetime:this.paybill.create_datetime,
            fee_price:this.paybill.fee_price,
            vat:this.paybill.vat,
            vat_rate:this.paybill.vat_rate,
            total_price:this.paybill.total_price,
            payment_type_id:this.paytype
          },"invoice/update-invoce").then((result)=>{
            this.isLoading=false;
            Swal.fire({
              title:  this.language.updated,
              text:  '',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
          }).then((result) => {
              this.refreshData();
            })
          },err=>{
           Swal.fire({
      title:  this.language.no_internet_alert,
      text:  '',
      type: 'error',
      showCancelButton: false,
      showConfirmButton: false,
      timer:2000
    });
            this.isLoading=false;
          })
        }
      });


    }
  }
  formatDate(date) {
    var monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var hour=date.getHours();
    var min=date.getMinutes();
    var sec=date.getSeconds();
    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }
  delete(bill){
    Swal.fire({
      title: this.language.confirm_delete,
      text: this.language.warining_delete,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.language.want_delete,
      cancelButtonText: this.language.close
    }).then((result) => {
      if (result.value) {

        this.service.postData({invoice_id:bill.invoice_id},"invoice/cancel-invoice").then(result=>{
          this.isLoading=false;
          Swal.fire({
      title: this.language.deleted,
      text: '',
      type: 'success',
      showCancelButton: false,
      showConfirmButton: false,
      timer:2000
    }).then((result) => {
            this.refreshData();
          })
        },err=>{
         Swal.fire({
      title:  this.language.no_internet_alert,
      text:  '',
      type: 'error',
      showCancelButton: false,
      showConfirmButton: false,
      timer:2000
    });
          this.isLoading=false;
        })
      }
    });
  }
  update(){
    // this.paybill=bill;
    this.action=this.actions[1];
    this.isLoading=true;
    // this.vat_price=(1-parseFloat(bill.vat))*parseFloat(bill.total_price);
    //  this.isLoading=true;
    this.selected_items=this.all_paybill.filter((item)=>item.check);
    this.sum=0;
    this.selected_items.forEach((item)=>{
      this.sum+=parseInt(item.total_price);
    });
    this.service.postData({},"payment-type/get").then((result)=>{
      this.payments=result;
      this.isLoading=false;

    },err=>{
      console.log(err)
    })
  }
  cancel(){
    this.refreshData();
  }
  pay(){
    this.submitted=true;
    if(this.isFloat(this.discount)&&this.payment_id!=""){
              Swal.fire({
                title: this.language.confirm_update,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.language.want_update,
                cancelButtonText: this.language.close
              }).then((result) => {

                if (result.value) {
                  this.isLoading=true;
                  this.service.postData({
                    data:this.selected_items.map((item)=>item.invoice_id),
                    discount:this.discount,
                    remark:this.remark,
                    payment_id:this.payment_id,
                    total_price:this.sum,
                    user_id:this.user.username
                  },"invoice/update-invoice").then((result)=>{
                    this.isLoading=false;
                    Swal.fire({
                      title:  this.language.updated,
                      text:  '',
                      type: 'success',
                      showCancelButton: false,
                      showConfirmButton: false,
                      timer:2000
                  }).then((result) => {
                      this.refreshData();
                    })
                  },err=>{
                  Swal.fire({
              title:  this.language.no_internet_alert,
              text:  '',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            });
            this.isLoading=false;
          })
        }
      });
    }
  }
  remove(item){
    var index=-1;
    for(var i=0;i<this.selected_items.length;i++){
      if(this.selected_items[i].invoice_id==item.invoice_id){
        index=i;
        break;
      }
    }
    if(index!=-1){
      this.selected_items.splice(index,1);
    }
  }
  isFloat=value=> !/^\s*$/.test(value) && !isNaN(value)

}
